import { Injectable } from '@angular/core';
import { ActivatedRouteSnapshot } from '@angular/router';
import { tap } from "rxjs/operators";
import { LoaderService } from '../../common/services/loader.service';
import { WorkOrderService } from '../services/work-order.service';

@Injectable()
export class WorkOrderResolver  {
    constructor( public dataService: WorkOrderService, public loaderService: LoaderService ) {
    }

    resolve(route: ActivatedRouteSnapshot) {
        this.loaderService.toggleLoader(true);
        const workOrder = this.dataService.getWorkOrder(route.paramMap.get('workOrderId'));
        return workOrder.pipe(tap((data) => {
            this.loaderService.toggleLoader(false);
        }));
    }
}